import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import Modal from 'components/_molecules/Modal'
import VideoPlayer from 'components/_molecules/VideoPlayer'
import BlogDisplay from 'components/BlogDisplay'

// TODO move this to global redux state
import { getNextPreviousMedia } from 'redux/utils'

import './styles.css'

class MediaModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    mediaId: PropTypes.string.isRequired,
    // tripMedia,
    // tripData
    // videoResolutionDisplay,
    actions: PropTypes.shape({
      navViewMedia: PropTypes.func.isRequired,
      navCloseMedia: PropTypes.func.isRequired,
    }).isRequired,
  }
  static defaultProps = {
    modalTitle: '',
  }
  render() {
    const {
      isOpen,
      onRequestClose,
      mediaId,
      tripMedia,
      tripData,
      videoResolutionDisplay,
      actions,
    } = this.props

    const { setVideoResolutionDisplay } = this.props.actions

    const media = tripMedia[mediaId]

    const title = media.title || 'Media'
    const { type, value, origin } = media

    const nextPreviousMedia = getNextPreviousMedia({ mediaId, mediaType: type, events: tripData.events   })
    let nextPreviousLinks

    if (nextPreviousMedia){
      const previousMediaLink = (nextPreviousMedia.previousMedia) ? <div className="previous-media-link" onClick={() => { actions.navViewMedia({ mediaId: nextPreviousMedia.previousMedia.mediaId }) }}>Prev</div> : undefined;
      const nextMediaLink = (nextPreviousMedia.nextMedia) ? <div className="next-media-link" onClick={() => { actions.navViewMedia({ mediaId: nextPreviousMedia.nextMedia.mediaId }) }}>Next</div> : undefined;
      nextPreviousLinks = (
          <div className="next-previous-media-links">
            {previousMediaLink}
            {nextMediaLink}
          </div>
      )
    }

    let mediaContent = <div>media content placeholder</div>

    if (type === 'video' && origin === 'vimeo'){
      mediaContent =
        <VideoPlayer
          type="iframe"
          source={value.url}
          resolutionType={videoResolutionDisplay}
        />
    }

    if (type === 'video' && origin === 'url'){
      const setHighResolutionDisplay = () => { setVideoResolutionDisplay({ videoResolutionDisplay: 'high' }) }
      const setLowResolutionDisplay = () => { setVideoResolutionDisplay({ videoResolutionDisplay: 'low' }) }
      mediaContent =
        <VideoPlayer
          type="html5"
          source={value.filePath}
          lowResSource={value.lowResFilePath}
          resolutionType={videoResolutionDisplay}
          setHighResolutionDisplay={setHighResolutionDisplay}
          setLowResolutionDisplay={setLowResolutionDisplay}
        />
    }

    if (type === 'blog'){
      const { contentType: type, content } = value
      mediaContent = <div className="blog-text">{value.content}</div>
      mediaContent =
        <BlogDisplay
          type={type}
          content={content}
        />
    }

    return (
      <Modal
        isOpen={isOpen}
        modalTitle={title}
        modalHeaderSeperator
        onRequestClose={onRequestClose}
        shouldCloseOnOverlayClick={false}
        additionalClassName="media-modal"
      >
        {nextPreviousLinks}
        {mediaContent}
      </Modal>
    )
  }
}

export default MediaModal



// WEBPACK FOOTER //
// ./src/components/MediaModal/component.js